import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RedirectProps } from 'react-router-dom';

import { ProductType } from '@tink/core/src/types';
import { fetchProviders as fetchProvidersImport } from '../../services/providers';
import { AppState } from '../../stores/redux-store';
import { isExtendConsent, isUpdateConsent, ProductDimension } from '../../models/product';
import { useUrlQuery } from '../ApplicationProviders/UrlQueryProvider/UrlQueryProvider';

export type ProviderInitiatorProps = PropsFromRedux & {
  productType: ProductType;
  productDimension: ProductDimension;
  children: React.ReactNode;
  RedirectComponent?: React.ComponentType<RedirectProps>;
};

export const ProviderInitiatorPresenter = ({
  children,
  productType,
  productDimension,
  user,
  fetchProviders,
}: ProviderInitiatorProps) => {
  const doNotFetchProviders =
    isUpdateConsent(productType, productDimension) || isExtendConsent(productDimension);
  const { market, locale } = useUrlQuery();

  useEffect(() => {
    if (user) {
      if (!doNotFetchProviders) {
        fetchProviders({
          market,
          locale,
          productType,
          productDimension,
        });
      }
    }
  }, [doNotFetchProviders, fetchProviders, locale, market, productDimension, productType, user]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

const mapStateToProps = (state: AppState) => ({
  user: state.user.user,
});

const mapDispatchToProps = {
  fetchProviders: fetchProvidersImport,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export const ProviderInitiator = connector(ProviderInitiatorPresenter);
